export type LeadStatus =
  | 'new_lead'
  | 'lead'
  | 'progress'
  | 'qualified'
  | 'pending'
  | 'converted';

export type LeadGender = 'Male' | 'Female';

export interface LeadSourceOption {
  id: number;
  name: string;
}

export interface LeadFormFields {
  leadDate?: string | null;
  counsellorName?: string | null;
  age?: string | null;
  qualification?: string | null;
  occupation?: string | null;
  caste?: string | null;
  height?: string | null;
  maritalStatus?: string | null;
  divorceInfo?: string | null;
  location?: string | null;
  requirements?: string | null;
  remarks1stTime?: string | null;
  secondCallDate?: string | null;
  thirdCallDate?: string | null;
  biodataReceived?: string | null;
  profileCreated?: string | null;
  membership?: string | null;
  amountProfilesShared?: string | null;
  shared?: string | null;
  left?: string | null;
  retainerFormSent?: string | null;
  retainerSigned?: string | null;
  anyOtherRemark?: string | null;
}

export interface LeadTaskAssignee {
  userId: number;
  name: string | null;
  avatarUrl: string | null;
}

export interface Lead extends LeadFormFields {
  leadId: string;
  leadUniqueId: string;
  userId: number | null;
  fullName: string;
  taskAssignee: LeadTaskAssignee | null;
  email: string;
  phoneNumber: string | null;
  leadSource: LeadSourceOption | null;
  status: LeadStatus;
  gender: string | null;
  preferredGender: string | null;
  notes: string | null;
  convertedUserId: number | null;
  convertedAt: string | null;
  createdByUserId: number;
  createdAt: string;
  modifiedAt: string;
  /** @deprecated UI compat — derived from fullName */
  firstName?: string;
  /** @deprecated UI compat — derived from fullName */
  lastName?: string;
  /** @deprecated UI compat — leadSource.name */
  source?: string;
  uniqueId?: string;
}

export interface CreateLeadRequest extends LeadFormFields {
  fullName: string;
  email: string;
  leadSourceId: number;
  phoneNumber?: string;
  status?: Exclude<LeadStatus, 'converted'>;
  gender?: LeadGender;
  preferredGender?: LeadGender;
  notes?: string;
  remark?: string;
}

export interface UpdateLeadRequest extends LeadFormFields {
  fullName?: string;
  email?: string;
  phoneNumber?: string;
  leadSourceId?: number;
  status?: Exclude<LeadStatus, 'converted'>;
  gender?: LeadGender;
  preferredGender?: LeadGender;
  notes?: string;
}

export interface SearchLeadsRequest {
  page?: number;
  limit?: number;
  tab?: 'all';
  search?: string;
  lead_type?: number;
  status?: LeadStatus;
  gender?: LeadGender;
}

export interface BulkExportLeadsRequest {
  leadIds?: number[];
  filters?: Partial<SearchLeadsRequest>;
  format?: 'xlsx' | 'csv';
  asFile?: boolean;
}

export interface BulkExportLeadsResponse {
  exportedCount: number;
  filename: string;
  contentType: string;
  contentBase64?: string;
  csv?: string;
}

export interface ImportLeadsResponse {
  imported: number;
  failed: number;
  errors: { row: number; message: string }[];
}

export interface BulkCreateTaskRequest {
  leadIds: number[];
  title?: string;
  assigneeUserId?: number;
}

export interface BulkCreateTaskResponse {
  createdLeadIds: number[];
  createdLeadUniqueIds: string[];
  createdLeadUserIds: number[];
  skippedLeadIds: number[];
  skippedLeadUniqueIds: string[];
  skippedLeadUserIds: (number | null)[];
}

export interface TaskAssigneeOption {
  userId: number;
  name: string;
  email?: string;
  role?: string | null;
}

export const LEAD_IMPORT_ACCEPT = '.csv,.xlsx,.xls';

export const isLeadImportFile = (filename: string): boolean =>
  /\.(csv|xlsx|xls)$/i.test(filename);
